var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "12px", "padding-top": "0", height: "100%" } },
    [
      ((_vm.announcementList.length > 0 && _vm.announcementList[0].type == 2) ||
        _vm.newsImg.length > 0) &&
      !_vm.difChannelType.isFullScreen
        ? _c(
            "div",
            { staticClass: "gg-card", staticStyle: { height: "99%" } },
            [
              _vm.newsImg.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "u-flex u-row-between",
                      staticStyle: {
                        height: "100%",
                        "align-items": "flex-start",
                      },
                    },
                    [
                      _vm.newsImg.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "gg_card_content u-flex-col",
                              staticStyle: { "max-height": "100%" },
                              style: {
                                width: !(
                                  _vm.announcementList.length > 0 &&
                                  _vm.announcementList[0].type == 2
                                )
                                  ? "100%"
                                  : "calc(50% - 10px)",
                              },
                            },
                            [
                              _c("div", { staticClass: "gg_card_header" }, [
                                _c("span", { staticClass: "gg_card_title" }, [
                                  _vm._v("重要公告"),
                                ]),
                                _vm.newsImg.length > 2
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "u-flex gg_card_more",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onToNews(
                                              _vm.newsImg[0],
                                              0
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("更多 >")]
                                    )
                                  : _vm._e(),
                              ]),
                              _c(
                                "div",
                                { staticClass: "gg_card_content_list" },
                                _vm._l(_vm.newsImg, function (item, index) {
                                  return _c(
                                    "el-card",
                                    {
                                      key: index,
                                      staticClass: "u-margin-bottom-12",
                                      staticStyle: { width: "100%" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "gg_card_item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onToNews(item, index)
                                            },
                                          },
                                        },
                                        [
                                          item.coverImage
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "image-wrapper",
                                                },
                                                [
                                                  _c("el-image", {
                                                    staticStyle: {
                                                      width: "100%",
                                                      height: "100%",
                                                    },
                                                    attrs: {
                                                      src: item.coverImage,
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "gg_card_item_title",
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(item.name) +
                                                  "\n\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "u-flex u-col-center u-margin-top-4",
                                              staticStyle: {
                                                "font-size": "14px",
                                                color: "#999",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-date",
                                                staticStyle: {
                                                  "margin-right": "4px",
                                                },
                                              }),
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    item.effectBegin.substring(
                                                      0,
                                                      10
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.announcementList.length > 0 &&
                      _vm.announcementList[0].type == 2
                        ? _c(
                            "div",
                            {
                              staticClass: "gg_card_content u-flex-col",
                              staticStyle: {
                                "max-height": "100%",
                                overflow: "auto",
                              },
                              style: {
                                width: !(_vm.newsImg.length > 0)
                                  ? "100%"
                                  : "calc(50% - 10px)",
                              },
                            },
                            [
                              _vm._m(0),
                              _c(
                                "div",
                                { staticClass: "gg_card_content_list" },
                                [
                                  _c(
                                    "el-card",
                                    { staticStyle: { width: "100%" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "gg_card_item",
                                          staticStyle: {
                                            height: "calc(100vh - 280px)",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                width: "100%",
                                                height: "100%",
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "100%",
                                                  height: "100%",
                                                },
                                                attrs: {
                                                  src:
                                                    _vm.announcementList[0]
                                                      .bannerImage ||
                                                    "https://file.meibaokeji.com/assets/images/wei_fl_bg.png",
                                                  alt: "",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "absolute",
                                                    top: "5%",
                                                    left: "50%",
                                                    transform:
                                                      "translateX(-50%)",
                                                    "font-size": "18px",
                                                    "font-weight": "bold",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.announcementList[0]
                                                          .title || ""
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t"
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    position: "absolute",
                                                    top: "20%",
                                                    left: "50%",
                                                    transform:
                                                      "translateX(-50%)",
                                                    width: "82%",
                                                    height: "71%",
                                                    display: "flex-col",
                                                    overflow: "auto",
                                                  },
                                                },
                                                [
                                                  _vm._l(
                                                    _vm.announcementList[0]
                                                      .extra,
                                                    function (item, index) {
                                                      return [
                                                        _c("div", {
                                                          key: index,
                                                          staticStyle: {
                                                            width: "100%",
                                                            height:
                                                              "fit-content",
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              item.value
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "gg_card_item_title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.announcementList[0]
                                                    .title || ""
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "12px",
                                                color: "#949aad",
                                                height: "61%",
                                                overflow: "auto",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.announcementList[0]
                                                      .description || ""
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "u-flex u-col-center u-margin-top-12",
                                              staticStyle: {
                                                "font-size": "14px",
                                                color: "#999",
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-date",
                                                staticStyle: {
                                                  "margin-right": "4px",
                                                },
                                              }),
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.announcementList[0].updateTime.substring(
                                                      0,
                                                      10
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _c("el-card", { staticStyle: { height: "calc(100% - 20px)" } }, [
            _c("div", { staticClass: "banner-text" }, [
              _c("img", { attrs: { src: "images/welcome.png" } }),
              _c("br"),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "center",
                    "margin-top": "10px",
                    "font-size": "14px",
                  },
                },
                [
                  _vm.versionCode && _vm.versionCode !== ""
                    ? _c("span", [_vm._v("版本号：" + _vm._s(_vm.versionCode))])
                    : _vm._e(),
                ]
              ),
            ]),
          ]),
      _c(
        "el-dialog",
        {
          staticClass: "news-dialog",
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            visible: _vm.isShowNews,
            "append-to-body": "",
            "destroy-on-close": "",
            top: "2vh",
            width: "55%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowNews = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "u-flex-col",
              staticStyle: { position: "relative" },
              on: {
                mouseenter: function ($event) {
                  _vm.newsAutoplay = false
                },
                mouseleave: function ($event) {
                  _vm.newsAutoplay = true
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    "z-index": "99",
                    "font-size": "20px",
                    color: "#fff",
                    cursor: "pointer",
                  },
                },
                [
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.countNum == 0,
                        expression: "countNum == 0",
                      },
                    ],
                    staticClass: "el-icon-close",
                    on: { click: _vm.onCloseNews },
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.countNum != 0,
                          expression: "countNum != 0",
                        },
                      ],
                      staticStyle: { color: "#333" },
                    },
                    [_vm._v(_vm._s(_vm.countNum))]
                  ),
                ]
              ),
              _c(
                "el-carousel",
                {
                  ref: "carouselImg",
                  attrs: {
                    height: "90vh",
                    "indicator-position": "none",
                    autoplay: _vm.newsAutoplay,
                  },
                  on: { change: _vm.onChange },
                },
                _vm._l(_vm.newsImg, function (itemData) {
                  return _c("el-carousel-item", { key: itemData.id }, [
                    _c("div", { staticClass: "u-flex-col" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "changeBg-content u-flex u-row-start u-col-center",
                          staticStyle: { padding: "20px" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "15px",
                                "font-weight": "bold",
                                color: "#333",
                              },
                            },
                            [_vm._v("重要公告")]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "u-flex-col u-col-center",
                          staticStyle: {
                            width: "100%",
                            background: "#fff",
                            padding: "12px 36px 36px 36px",
                            height: "80vh",
                            overflow: "auto",
                            position: "relative",
                            "align-items": "flex-start",
                          },
                        },
                        [
                          _c("div", { staticClass: "u-flex-col" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "16px",
                                  "font-weight": "bold",
                                  color: "#333",
                                },
                              },
                              [_vm._v(_vm._s(itemData.name))]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "u-flex u-col-center u-margin-top-8",
                                staticStyle: {
                                  "justify-content": "flex-start",
                                  "font-size": "14px",
                                  color: "#999",
                                  width: "100%",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-date",
                                  staticStyle: {
                                    "margin-right": "4px",
                                    transform: "translateY(1px)",
                                  },
                                }),
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      itemData.effectBegin.substring(0, 10)
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]),
                          _c("el-divider"),
                          _c("div", {
                            staticStyle: { width: "100%", overflow: "auto" },
                            style: {
                              height:
                                itemData.fileCollect &&
                                itemData.fileCollect.length > 0
                                  ? "22vw"
                                  : "72vw",
                            },
                            domProps: { innerHTML: _vm._s(itemData.html) },
                          }),
                          itemData.fileCollect &&
                          itemData.fileCollect.length > 0
                            ? _c("el-divider")
                            : _vm._e(),
                          _c(
                            "div",
                            { staticStyle: { width: "100%", height: "20vh" } },
                            [
                              itemData.fileCollect &&
                              itemData.fileCollect.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "u-flex-col file-list-container",
                                      staticStyle: {
                                        width: "100%",
                                        height: "9vw",
                                        overflow: "auto",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "xg_title" }, [
                                        _c("span", [_vm._v("相关文件")]),
                                      ]),
                                      _vm._l(
                                        itemData.fileCollect,
                                        function (o, oIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key: oIndex,
                                              staticClass:
                                                "u-flex u-row-between",
                                              style: {
                                                "margin-top":
                                                  oIndex > 0 ? "12px" : "0",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "u-flex u-col-center",
                                                },
                                                [
                                                  _c("img", {
                                                    staticStyle: {
                                                      width: "24px",
                                                      height: "24px",
                                                      "margin-right": "8px",
                                                    },
                                                    attrs: {
                                                      src: _vm.getFileIcon(
                                                        o.url
                                                      ),
                                                      alt: "",
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v(_vm._s(o.name)),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openFile(o.url)
                                                    },
                                                  },
                                                },
                                                [_vm._v("查看")]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ])
                }),
                1
              ),
              _c(
                "div",
                {
                  staticClass: "u-flex bottom_text",
                  staticStyle: {
                    position: "absolute",
                    "z-index": "999",
                    bottom: "2px",
                    cursor: "pointer",
                    height: "60px",
                    width: "100%",
                  },
                },
                _vm._l(_vm.newsImg, function (itemData, index) {
                  return _c(
                    "div",
                    {
                      key: itemData.id,
                      staticClass:
                        "u-flex u-row-center u-col-center bottom_content",
                      class: {
                        changeBg:
                          _vm.newsImg[_vm.currentIndex].id === itemData.id,
                      },
                      style: { width: 100 / _vm.newsImg.length + "%" },
                      on: {
                        click: function ($event) {
                          return _vm.setActiveItem(index)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(itemData.name) + "\n\t\t\t\t"
                      ),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.readData.title,
            visible: _vm.readFlag,
            "append-to-body": "",
            top: "5vh",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.readFlag = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { height: "75vh", overflow: "auto" } }, [
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.readData.content) },
            }),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.moreAnnouncementFlag,
            "append-to-body": "",
            title: "通知公告",
            top: "5vh",
            width: "62%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.moreAnnouncementFlag = $event
            },
          },
        },
        [
          _vm._l(_vm.announcementList, function (item, index) {
            return [
              item.type == 1
                ? _c(
                    "div",
                    {
                      key: index,
                      staticClass: "u-flex-col",
                      staticStyle: { padding: "24px", cursor: "pointer" },
                      style: {
                        "border-bottom":
                          index != _vm.announcementList.length - 1
                            ? "1px solid #e6e6e6"
                            : "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.readAnnouncement(item)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "u-flex" },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "20px",
                                "font-weight": "bold",
                              },
                            },
                            [_vm._v(_vm._s(item.title || ""))]
                          ),
                          item.readFlag == 0
                            ? _c(
                                "el-tag",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: { effect: "dark", type: "danger" },
                                },
                                [_vm._v("未读")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "24px",
                            color: "#949aad",
                            height: "200px",
                            overflow: "auto",
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(item.description || "") +
                              "\n\t\t\t\t"
                          ),
                        ]
                      ),
                      _c("div", { staticStyle: { color: "#949aad" } }, [
                        _vm._v(_vm._s(item.updateTime || "")),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          staticClass: "year-report-dialog",
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            visible: _vm.isShowNzzj,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowNzzj = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "year_report_main" },
            [
              _c(
                "div",
                {
                  staticClass: "close-icon",
                  staticStyle: {
                    position: "absolute",
                    top: "12px",
                    right: "-42px",
                    "z-index": "99",
                    "font-size": "28px",
                    color: "#fff",
                    cursor: "pointer",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-close",
                    on: { click: _vm.onCloseNzzj },
                  }),
                ]
              ),
              _c("newYearReportModal"),
            ],
            1
          ),
        ]
      ),
      _c("InsureNotices", {
        ref: "refInsureNotices",
        attrs: { "is-can-close": false },
        on: {
          onToCancel: function ($event) {
            return _vm.onToSureEnd(0)
          },
          onToSureEnd: function ($event) {
            return _vm.onToSureEnd(1)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gg_card_header" }, [
      _c("span", { staticClass: "gg_card_title" }, [_vm._v("费率公告")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }